export default {
    undefined: '',
    Username: 'Usuario',
    Password: 'Contraseña',
    'Log In': 'Iniciar sesión',
    'Invalid username and password combination':
        'Combinación inválida de usuario y contraseña',
    'User not found': 'Usuario no encontrado',
    'An unexpected error has occurred trying to get the companies, please try again':
        'Ha ocurrido un error inesperado al intentar obtener la lista de companías, por favor intenta nuevamente',
    'An unexpected error has occurred, please try again':
        'Ha ocurrido un error inesperado, por favor intente de nuevo',
    Search: 'Buscar',
    'Unexpected warning message format':
        'Formato inesperado del mensaje de advertencia',
    'Enter your password': 'Ingresa tu contraseňa',
    'Username is required': 'Usuario es requerido',
    'Password is required': 'Contraseňa es requerida',
    'Log out': 'Cerrar sesión',
    'Select a company': 'Seleccione una compañía',
    Home: 'Inicio',
    Administration: 'Administración',
    Settings: 'Configuraciones',
    Subscription: 'Suscripción',
    Users: 'Usuarios',
    'Delete status': 'Eliminar estado',
    List: 'Listar',
    Create: 'Crear',
    Manage: 'Administrar',
    Agents: 'Agentes',
    Clients: 'Clientes',
    Cities: 'Ciudades',
    Places: 'Lugares',
    Regions: 'Regiones',
    States: 'Estados',
    Countries: 'Países',
    Packages: 'Paquetes',
    Plan: 'Plan',
    Payments: 'Pagos',
    Status: 'Estatus',
    'Paypal data': 'Datos paypal',
    Actions: 'Acciones',
    DELIVERED: 'ENTREGADO',
    Columns: 'Columnas',
    Number: 'Número',
    Date: 'Fecha',
    Receiver: 'Destinatario',
    Agency: 'Agencia',
    Dimensions: 'Dimensiones',
    Weight: 'Peso',
    Volume: 'Volumen',
    Description: 'Descripción',
    Value: 'Valor',
    'Total cargo value': 'Valor total de carga',
    Received: 'Recibido',
    'Received by': 'Recibido por',
    'Are you sure you want to remove this status?':
        '¿Estas seguro que deseas eliminar este estatus?',
    New: 'Nuevo',
    Details: 'Detalles',
    Attachments: 'Adjuntos',
    Location: 'Ubicación',
    Shipper: 'Remitente',
    Consignee: 'Destinatario',
    Creation: 'Creación',
    Pieces: 'Piezas',
    Type: 'Tipo',
    'Items per page': 'Resultados por página',
    Loading: 'Cargando',
    'Try again': 'Intentar de nuevo',
    'No available data': 'No se encontraron resultados',
    'Selected for': 'Seleccionado para',
    Shipping: 'Envío',
    'Vol. Weight': 'Peso vol.',
    Carrier: 'Transportista',
    Remove: 'Eliminar',
    Edit: 'Editar',
    'Submitted by connect': 'Enviado por connect',
    Voided: 'Anulado',
    Anulado: 'Anulado',
    Entregado: 'Entregado',
    Reempacado: 'Reempacado',
    Repackaged: 'Reempacado',
    PENDIENTE: 'PENDIENTE',
    PAGADO: 'PAGADO',
    ANULADA: 'ANULADA',
    Procesado: 'Procesado',
    'Por procesar': 'Por procesar',
    Aéreo: 'Aéreo',
    Marítimo: 'Marítimo',
    Terrestre: 'Terrestre',
    Caja: 'Caja',
    Ninguna: 'Ninguna',
    Select: 'Seleccione',
    'Shipping type': 'Tipo de envío',
    Void: 'Anulado',
    'No void': 'No anulado',
    From: 'Desde',
    To: 'Hasta',
    User: 'Usuario',
    Agent: 'Agente',
    'form.errors':
        'Sin errores. | Se ha detectado un detalle. Por favor, revísalo y corrígelo. | Este formulario contiene {count} detalles. Por favor, revísalos y corrígelos.',
    'Create status': 'Crear estatus',
    Finish: 'Terminar',
    'Print label': 'Imprimir etiqueta',
    'Custom Labels': 'Otras Etiquetas',
    'Send by email': 'Enviar por correo electrónico',
    'Send by message': 'Enviar por mensaje',
    Print: 'Imprimir',
    General: 'General',
    'Send email to shipper': 'Enviar correo electrónico al remitente',
    'Send email to consignee': 'Enviar correo electrónico al destinatario',
    'Whatsapp notification to shipper':
        'Notificación por Whatsapp al remitente',
    'Whatsapp notification to consignee':
        'Notificación por Whatsapp al destinatario',
    'Package type': 'Tipo de paquete',
    Length: 'Longitud',
    Width: 'Ancho',
    Height: 'Altura',
    Documents: 'Documentos',
    Document: 'Documento',
    Images: 'Imágenes',
    Name: 'Nombre',
    State: 'Estado',
    Country: 'País',
    Latitude: 'Latitud',
    Longitude: 'Longitud',
    'Warehouse Receipt': 'Recibo de almacén',
    'Warehouse Receipts': 'Recibos de almacén',
    'There are no pictures to show in this view':
        'No hay imágenes para mostrar en esta vista',
    Save: 'Guardar',
    Invoice: 'Factura',
    Consolidated: 'Consolidado',
    Totals: 'Totales',
    WVol: 'PVol',
    Instructions: 'Instrucciones',
    Warehouses: 'Warehouses',
    'Origin number': 'Número origen',
    'Destination number': 'Número destino',
    'Shipper email': 'Email remitente',
    'Consignee email': 'Email destinatario',
    'Delivery list': 'Lista entregas',
    'Destination Country': 'País Destino',
    Repacked: 'Reempacados',
    Normal: 'Normal',
    Destination: 'Destino',
    Tracking: 'Tracking',
    Cancel: 'Cancelar',
    Confirm: 'Confirmar',
    Reason: 'Motivo',
    'Reason is required with at least {min} characters':
        'El motivo es obligatorio y debe tener al menos {min} caracteres',
    Rejection: 'Rechazo',
    'Rejection Date': 'Fecha de Rechazo',
    'Rejection Reason': 'Motivo de Rechazo',
    'Some packages could not be added to the warehouse':
        'Algunos paquetes no pudieron ser agregados al almacén',
    Undo: 'Deshacer',
    'Confirm Remove Package':
        '¿Desea continuar con la eliminación del paquete número {packagenumber}?',
    'Confirm Remove Warehouse':
        '¿Desea continuar con la eliminación del warehouse número {warehousenumber}?',
    'Cannot Remove Package':
        'No se puede eliminar el paquete {packagenumber}; se procesa en {processedIn}',
    'Cannot Remove Warehouse':
        'No se puede eliminar el warehouse {warehousenumber}; ya fue anulado',
    'Cannot Remove Processed Warehouse':
        'No se puede eliminar el warehouse {warehousenumber}; ya fue procesado',
    'Cannot Reject Repack':
        'No se puede rechazar la solicitud de reempaque {repackingNumber}; ya fue rechazada o procesado',
    'Confirm Reject Request':
        '¿Desea continuar con la eliminación de la solicitud de reempaque número {repackingNumber}?',
    'Multiple Remove Item':
        'Te gustaría proceder con la eliminación del item identificado como {itemIdentifier}?',
    Package: 'Paquete | Paquetes',
    max_resolution_error:
        'Las dimensiones de la imagen deberían ser {width}x{height} o menores.',
    Close: 'Cerrar',
    Ending: 'Finalizar',
    Company: 'Empresa',
    'Document ID': 'Numero de Identificación',
    'City, State, Zip Code': 'Ciudad, Estado, Código Postal',
    'Phone, Mobile': 'Teléfono, Móvil',
    'State Status': 'Estado',
    Processed: 'Procesado',
    Unprocessed: 'Por procesar',
    'Send email': 'Enviar email',
    'Confirm Send Email':
        'Se enviará un mensaje del {entity} {number}, seleccione el destinatario:',
    Other: 'Otro',
    'Enter Email': 'Ingrese el correo electrónico',
    Send: 'Enviar',
    Sent: 'Enviado',
    'Could Not': 'Could not {action}',
    'Action Successfully': '¡{action} exitosamente!',
    'Error en los datos': 'Error en los datos',
    'Load Units': 'Unidades de carga',
    Shipment: 'Guía',
    'Create package': 'Crear paquete',
    'Edit package': 'Editar paquete',
    Lastname: 'Apellido',
    Email: 'Correo electrónico',
    Address: 'Dirección',
    City: 'Ciudad',
    Phone: 'Teléfono',
    'Could Not Remove': 'No se pudo eliminar',
    Yes: 'Si',
    'Removing Package': 'Eliminando paquete',
    No: 'No',
    Ok: 'OK',
    Showing: 'Mostrando',
    items: 'registros',
    Previous: 'ANTERIOR',
    Next: 'SIGUIENTE',
    'No puede ser editado': 'No puede ser editado',
    Prepack: 'Entrada de Almacén',
    Prepacks: 'Entradas de Almacén',
    'Repackaging type': 'Tipo de reempaque',
    Code: 'Código',
    'Upload image': 'Subir imagen',
    'Choose image': 'Elegir imagen',
    Upload: 'Subir',
    'New Status': 'Nuevo Status',
    Comment: 'Comentarios',
    External: 'Externo',
    'New Status for': 'Nuevo Estatus para',
    'Print PDF': 'Imprimir PDF',
    'Please, Try later': 'Por favor intente mas tarde',
    'Processed In': 'Procesado En',
    Measure: 'Medida | Medidas',
    Origin: 'Origen',
    'Sending Company': 'Empresa de envío',
    Invoices: 'Facturas',
    'Max Amount': 'Monto máx.',
    'Min Amount': 'Monto min.',
    Pending: 'Pendiente',
    Paid: 'Pagado',
    Unpaid: 'No pagado',
    'Date Type': 'Tipo de fecha',
    'Creation Date': 'Fecha Creación',
    'Due Date': 'Fecha de Vencimiento',
    Amount: 'Monto',
    'Days Overdude': 'Días atrasados',
    Shipments: 'Guías',
    'Customer Address': 'Dirección del cliente',
    Customer: 'Cliente | Clientes',
    'Id Document': 'Id Documento',
    Tax: 'Impuesto',
    Taxes: 'Impuestos',
    'Payment Type': 'Tipo de pago',
    'Add Payment': 'Agregar pago',
    'Total Payment': 'Pago Total',
    'Applied to Invoices': 'Aplicado a Facturas',
    'Credit Balance': 'Saldo a Favor',
    'Applied to': 'Aplicado a',
    'Invoices Applied': 'Facturas Aplicadas',
    invoice: 'factura',
    invoices: 'facturas',
    label: 'Etiquetas',
    status: 'Estatus',
    Sobre: 'Sobre',
    'error.status':
        'Los elementos ({errorNumbers}) ya fueron enviados, no pueden recibir mas estatus',
    Currency: 'Moneda',
    'Payment Link': 'Enlace de pago',
    Delivered: 'Entregado',
    'Last Name': 'Apellido',
    'Customer Create': 'Crear Cliente',
    'Phone No.': 'Teléfono No.',
    'Mobile Phone No.': 'Teléfono Móvil No.',
    Mobile: 'Móvil',
    'Zip Code': 'Código Postal',
    Export: 'Exportar',
    'Export Data': 'Exportar Data',
    Filters: 'Filtros',
    'Download excel': 'Descargar a excel',
    'Preview PDF': 'Vista previa PDF',
    'Consolidated Type': 'Tipo consolidado',
    'Consolidated Types': 'Tipos consolidado',
    Refrigerado: 'Refrigerado',
    Express: 'Express',
    'Super Rapido': 'Súper rápido',
    Maritimo: 'Marítimo 45 - 60',
    'Consolidated Status': 'Estatus Consolidado',
    OPEN: 'ABIERTO',
    CLOSE: 'CERRADO',
    DELIVERY: 'ENTREGADO',
    Supplier: 'Proveedor',
    'Country From': 'País de origen',
    'Country To': 'País de destino',
    Sender: 'Remitente',
    'Total Pending': 'Total pendiente',
    Office: 'Oficina',
    'Bill Total': 'Gasto total',
    'Total Bills Paid': 'Gasto total pagado',
    'Total Profit': 'Ganancia total',
    Quantity: 'Cantidad',
    'Total Paid': 'Total pagado',
    'Total Due': 'Total vencido',
    'Total Expenses': 'Gastos Totales',
    Processor: 'Encargado',
    'Pickup Date': 'Fecha de pickup',
    'Pickup Hour': 'Hora de pickup',
    Pickup: 'Pickup',
    Pickups: 'Pickups',
    'Delivery List': 'Lista de Entrega',
    'Delivery Lists': 'Listas de Entrega',
    Identificador: 'Identificador',
    CREADA: 'CREADA',
    EJECUTADA: 'EJECUTADA',
    'Execution Date': 'Fecha de Ejecución',
    Driver: 'Conductor',
    Vehicle: 'Vehículo',
    'All Agency': 'Toda la Agencia',
    'All Destination': 'Todos los Destinos',
    'Delivery Comment': 'Comentario de Entrega',
    'Delivery Date': 'Fecha de Entrega',
    Open: 'Abierto',
    'Paid Type': 'Tipo de pago',
    'Pickup Address': 'Dirección de pickup',
    'Delivery Address': 'Dirección de entrega',
    Delivery: 'Entrega',
    'Operation Type': 'Tipo de operación',
    'Create Packages': 'Crear paquetes',
    Summary: 'Resumen',
    'Weight (Lb)': 'Peso (Lb)',
    'Volume (CF)': 'Volumen (CF)',
    Wvol: 'Wvol',
    Note: 'Nota',
    'Origin country': 'País origen',
    'Number Invoices': 'Número de Facturas',
    'Total Amount': 'Monto Total',
    'Outstanding Amount': 'Monto pendiente',
    'Estimated Cost': 'Costo estimado',
    'Estimated Profit': 'Ganancia estimada',
    Measures: 'Medidas',
    Condition: 'Condición',
    Alerts: 'Alertas',
    'Arrive Date': 'Fecha de llegada',
    'Declared Amount': 'Monto declarado',
    Arrival: 'Llegada',
    Insurance: 'Seguro',
    'Other Charges': 'Otros cargos',
    Commission: 'Comisión',
    Declared: 'Declarado',
    COD: 'COD',
    'Auxiliar Date': 'Fecha auxiliar',
    'Package Type': 'Tipo de paquete',
    'Rate Applied': 'Tarifa aplicada',
    'Fee Amount': 'Monto de la tarifa',
    Measurments: 'Mediciones',
    DII: 'DII',
    'Clear Signature': 'Limpiar Firma',
    'Close Receipt': 'Cerrar Paquete',
    'Mark Receipts': 'Marcar Paquete',
    'as delivered': 'como Entregado',
    'as undelivered': 'como no entregado',
    'Undo Ending': 'Deshacer Finalización',
    Signature: 'Firma',
    'Take a picture': 'Tomar una foto',
    'Upload picture': 'Subir una foto',
    'NOT ARRIVED': 'NO RECIBIDO',
    RECIBIDO: 'RECIBIDO',
    ARRIVED: 'RECIBIDO',
    ANULADO: 'ANULADO',
    PROCESADO: 'PROCESADO',
    'POR PROCESAR': 'POR PROCESAR',
    ENVIADO_CONNECT: 'ENVIADO POR CONNECT',
    REEMPACADO: 'REEMPACADO',
    'Create new customer': 'Crear nuevo cliente',
    Customers: 'Clientes',
    Multipays: 'Multipagos',
    Global: 'Global',
    'Balance Due': 'Saldo deudor',
    'Debit Credit': 'Débito / Crédito',
    'An unexpected error has occurred trying to print the label, please try again':
        'Ha ocurrido un error inesperado al intentar imprimir la etiqueta, por favor intente de nuevo',
    unexpected_error:
        'No se pudo completar la acción. Por favor, intenta de nuevo o contacta con el administrador.',
    'Package was not updated': 'El paquete no fue actualizado',
    'Sorry, this file type is not supported':
        'Lo siento, este tipo de archivo no es soportado',
    'Drop the file here': 'Arrastra el archivo aquí',
    'Drag and drop a file here, or click to select one':
        'Arrastra un archivo aquí o haz clic para seleccionar uno',
    'Take picture': 'Tomar foto',
    'Default Packages': 'Paquetes por defecto',
    'The package cannot be edited since is already processed':
        'El paquete no puede ser editado ya que está procesado',
    'Create Warehouse': 'Crear Warehouse',
    'Edit Shipper': 'Editar remitente',
    'You should select a shipper before create a consignee':
        'Debes seleccionar un remitente antes de crear un consignatario',
    'Edit Consignee': 'Editar consignatario',
    'Auxiliar Number': 'Número auxiliar',
    Referencia: 'Referencia',
    '': '',
    'Volumetric w.': 'Peso Volumétrico',
    Volumen: 'Volumen',
    'Items and Services': 'Ítems y servicios',
    item: 'ítem',
    Price: 'Precio',
    Qty: 'Cantidad',
    Total: 'Total',
    Modifiable: 'Modificable',
    'All Bill': 'Toda la factura',
    Services: 'Servicios',
    'There are no documents to show in this view':
        'No hay documentos para mostrar en esta vista',
    'Upload document': 'Subir documento',
    'Add Service': 'Agregar servicio',
    'Add Item': 'Agregar ítem',
    'Añadir artículo': 'Añadir artículo',
    'Guardar línea': 'Guardar línea',
    'Borrar línea': 'Borrar línea',
    'Do you want to delete this package line?':
        '¿Deseas eliminar esta línea de paquete?',
    'Escanear código de barras': 'Escanear código de barras',
    'Imprimir etiqueta': 'Imprimir etiqueta',
    'Peso volumétrico': 'Peso volumétrico',
    SOLICITADO: 'SOLICITADO',
    RECHAZADO: 'RECHAZADO',
    PROCESSED: 'PROCESSED',
    'PO Box': 'Apartado postal',
    'Shipping Type': 'Tipo de envío',
    Requested: 'Solicitado',
    Rejected: 'Rechazado',
    'Repacking Requests': 'Solicitudes de reempaque',
    Reject: 'Rechazar',
    All: 'Todos',
    Active: 'Activo',
    Inactive: 'Inactivo',
    'Create agent': 'Crear agente',
    'Edit agent': 'Editar agente',
    'Identification number': 'Número de identificacion',
    'Limit customer': 'Limitar cliente',
    'Edit type': 'Editar tipo',
    'Create type': 'Crear tipo',
    PackType: 'Tipo de paquete',
    'Template Pack': 'Pack estándar',
    'Template Packs': 'Packs estándar',
    'Package details': 'Datos del paquete',
    'User Type': 'Tipo de usuario',
    System: 'Sistema',
    Manager: 'Gerente',
    Agencies: 'Agencias',
    'Logistics Processes': 'Procesos Logísticos',
    'Manage POBox': 'Maneja Casilleros',
    'Conversion rate': 'Tasa de Conversión',
    'Send copy of Shipment': 'Envíar copia de Guías',
    'Share your Customer': 'Comparte sus clientes',
    'Customer editable by other agencies':
        'Clientes editables por otras agencias',
    'Allow Pickups': 'Maneja Pickups',
    'Create agency': 'Crear agencia',
    'Edit agency': 'Editar agencia',
    'Search customers only by Email': 'Buscar clientes solo por Email',
    'Visible from the Quote': 'Visible desde el Cotizador',
    'Display only the address of the current agency (not all of them)':
        'Desplegar solo la direccion de la agencia actual (no de todas)',
    'Allow customization': 'Permitir personalizar',
    'Whatsapp Image': 'Imagen para Whatsapp',
    'Air Pobox Address': 'Dirección de Casilleros Aéreos',
    'Sea Pobox Address': 'Dirección de Casilleros Marítimos',
    'PoboxAddress tooltip': '(Incluir Ciudad, Estado, Zipcode y País)',
    Bill: 'Factura',
    Prefix: 'Prefijos',
    Alert: 'Alertas',
    Init: 'Coorelativo inicial',
    Profile: 'Perfil',
    'Associated with': 'Asociado a',
    Subject: 'Asunto',
    'Title for Push notification (Mobile)':
        'Titulo para la notificación Push (Mobile)',
    'Text for Push notification (Mobile)':
        'Texto para la notificación Push (Mobile)',
    'Sending Images': 'Envío Imágenes',
    'Sending PDF': 'Envío PDF',
    'Body Email': 'Mensajes',
    'Edit body email': 'Editar mensaje',
    'Create body email': 'Crear mensaje',
    Body: 'Cuerpo',
    alert_number: 'Número Alerta',
    pobox_number: 'Número Casillero',
    consignee_description: 'Nombre Destinatario',
    shipper_description: 'Nombre Remitente',
    shipment_type: 'Tipo de Envío',
    company_name: 'Nombre Empresa',
    name_agency: 'Nombre Agencia',
    address_agency: 'Dirección Agencia',
    email_agency: 'Email Agencia',
    phone_agency: 'Teléfono Agencia',
    creation_date: 'Fecha de Creación',
    Labels: 'Etiquetas',
    Cost: 'Costo',
    Region: 'Región',
    'Warehouse Tariff': 'Tarifa Warehouse',
    'Warehouse Tariffs': 'Tarifas Warehouse',
    Range: 'Rango',
    Rate: 'Tarifa',
    Fixed: 'Fijo',
    'Tariff type': 'Tipo Tarifa',
    'Tariff Type': 'Tipo Tarifa',
    'Warehouse Management': 'Administar Almacen',
    Zone: 'Zona',
    Zones: 'Zonas',
    Locations: 'Ubicaciones',
    'Template Builder': 'Constructor de Plantillas',

    Acronym: 'Acrónimo',
    'Dimensional Factor (Volumetric Weight)':
        'Factor Dimensional (Peso Volumétrico)',
    'Volume Factor': 'Factor de Volumen',
    'TSA number': 'Número de TSA',
    'System Logo': 'Logo de Sistema',
    'Background image': 'Fondo de Pantalla de Acceso',
    'Billing Process': 'Proceso de Facturación',
    'Invoices paid when creating': 'Facturas pagas al crear',
    'Total Rounding': 'Redondeo Total',
    'Agencies can cancel invoices': 'Agencias pueden anular facturas',
    'Agencies can edit invoices': 'Agencias pueden editar facturas',
    'By Volume': 'Por Volumen',
    'By Weight': 'Por Peso',
    'Rounding Type': 'Tipo de Redondeo',
    Rates: 'Tarifas',
    'Show all rates when creating guide':
        'Mostrar todas las tarifas al crear guía',
    'Agencies can create consolidated': 'Agencias pueden crear consolidados',
    'Assign first status automatically':
        'Asignar primer status automáticamente',
    'Assign master agency to public lockers':
        'Asignar agencia master a casilleros públicos',
    'Customers can edit Locker data':
        'Clientes pueden editar datos de Casillero',
    'Create packages without measures': 'Crear paquetes sin medidas',
    'Send value declaration': 'Enviar declaración de valor',
    'Repackaging of packages with Association':
        'Rempaque de paquetes con Asociación',
    'Multi-client Repackaging Request': 'Solicitud de Reempaque Multicliente',
    'Sign declaration of value': 'Firma declaración de valor',
    'Note when repackaging Warehouses': 'Nota al reempacar Warehouses',
    'Agency for the elements': 'Agencia para los elementos',
    'POBOX Address': 'Direción Casillero',
    'POBOX Address2': 'Direción Casillero Auxiliar',
    'Locker Number': 'Número de Casillero',
    'Customer Name': 'Nombre de Cliente',
    'Module Activation': 'Activación de Módulos',
    Quote: 'Cotizador',
    'Functional Activation': 'Activación de Funcionalidades',
    'Custom rates (tariffs)': 'Tarifas personalizadas (aranceles)',
    'Label Formats by Agency': 'Formatos de Etiquetas por Agencia',
    'Save customer information': 'Guardar información de clientes',
    'Quotation Rates': 'Tarifas para Cotizador',
    'Social networks': 'Redes Sociales',
    Numbers: 'Números',
    Boarding: 'Embarque',
    'Customers and Lockers use the same number':
        'Clientes y Casilleros usan el mismo número',
    'Measures Units': 'Unidades de medida',
    'Weight Label': 'Etiqueta de Peso',
    Pounds: 'Libras',
    Kilogram: 'Kilogramo',
    'Volume Label': 'Etiqueta de Volumen',
    'Currency Label': 'Etiqueta de Moneda',
    Bolivars: 'Bolívares',
    'Pound sterling': 'Libra Esterlina',
    Pobox: 'Casillero',
    'Cubic Feet': 'Pies Cúbicos',
    'Cubic Meters': 'Metros Cúbicos',
    'Commissions to agents': 'Comisiones a agentes',
    'Initial number per agency': 'Número inicial por agencia',
    'Number of decimals': 'Candidad de decimales',
    'Warehouse rates with cost': 'Tarifas de Warehouse con costo',
    'Rates by rank': 'Tarifas por rango',
    'Rates with origin and destination': 'Tarifas con origen y destino',
    'Automatic rate for clients': 'Tarifa automática para clientes',
    'Add packages to Loadunits and Consolidates':
        'Agregar paquetes a Loadunits y Consolidados',
    'Open consolidated multiple peers':
        'Múltiples iguales consolidados abiertos',
    'Accept repeated Trackins': 'Aceptar Trackins repetidos',
    'Search addresses by customer': 'Buscar direcciones por cliente',
    'Email for express package': 'Email para paquete rápido',
    'Email for express Warehouse': 'Email para Warehouse rápido',
    'Select default recipient when selecting sender':
        'Seleccionar destinatario por defecto al seleccionar remitente',
    'Find clients without spaces': 'Buscar clientes sin espacios',
    'Search by exact poBox number': 'Buscar por número exacto de casillero',
    'Public PoBox users are created assets':
        'Usuarios de casilleros públicos se crean activos',
    'Mandatory Alert Tracking': 'Traking de Alertas obligatorio',
    'Deployment configuration': 'Despliegue',
    'Update Packet Entry Settings':
        'Actualizar Configuración de entrada de paquetes',
    'Packet Input Configuration': 'Configuración de entrada de paquetes',
    'Show agency email sending': 'Mostrar envío de email agencia',
    'Auxiliary label': 'Etiqueta del auxiliar',
    'Update Settings': 'Actualizar Configuración',
    'Mandatory tracking': 'Tracking obligatorio',
    'Mandatory value': 'Valor obligatorio',
    'Note Label': 'Etiqueta para Nota',
    'Editable from PoBox': 'Editable desde Casillero',
    'Order Volume units': 'Pedir unidades de Volumen',
    'Dimension Unit': 'Unidad de dimensión',
    'Global Weight': 'Peso Global',
    'Global Volume': 'Volumen Global',
    'Required Shipper': 'Remitente Obligatorio',
    'Mandatory Receiver': 'Destinatario Obligatorio',
    'Default Location': 'Ubicación por Omisión',
    'Mandatory Location': 'Ubicación Obligatoria',
    'Location Basic Data': 'Ubicación Datos Básicos',
    Beginning: 'Comienzo',
    End: 'Final',
    'Generate Label Automatically': 'Generar Etiqueta Automáticamente',
    'Send Email to Sender': 'Enviar Email al Remitente',
    'Send Email to Recipient': 'Enviar Email al Destinatario',
    'Allow processing packets with alert':
        'Permitir procesar paquetes con alerta',
    'Send Whatsapp to the Sender': 'Enviar Whatsapp al Remitente',
    'Send Whatsapp to the Recipient': 'Enviar Whatsapp al Destinatario',
    'Quick Package Options': 'Opciones Paquete Rápido',
    'Agent in Quick Package': 'Agente en Paquete Rápido',
    'Description in Quick Package': 'Descripción en Paquete Rápido',
    'Clear Agency Quick Package': 'Limpiar Agencia Paquete Rápido',
    'Quick packet with enter check':
        'Paquete rápido con control de enter (*necesita Remitente Obligatorio en falso)',
    'Show shipping type': 'Mostrar tipo de envío',
    'Show Measurements': 'Mostrar Medidas',
    'Show Carrier': 'Mostrar Carrier',
    'Show package type': 'Mostrar tipo de paquete',
    'Shipping subtype in Repackaging': 'Subtipo de envío en Reempaque',
    'Search Start Date': 'Fecha Inicial para Búsqueda',
    Day: 'Día',
    Week: 'Semana',
    Month: 'Mes',
    Months: 'Meses',
    'Arrival date': 'Fecha de llegada',
    'Image tag': 'Etiqueta de imagen',
    'Mandatory Aux': 'Auxiliar Obligatorio',
    'Document label': 'Etiqueta del documento',
    'Description label': 'Etiqueta de la descripción',
    'Send alert email': 'Enviar email de alerta',
    'Default values': 'Valores por omisión',
    'Express Entries': 'Entradas Rápidas',
    Billing: 'Facturación',
    'Dashboard Settings': 'Configuración de Dashboard',
    'Quick entry creation': 'Creación de entrada rápidas',
    'Package Creation': 'Creación de Paquetes',
    'Creating Alerts': 'Creación de Alertas',
    'Guide Creation': 'Creación de Guías',
    'Warehouse Creation': 'Creación de Warehouses',
    'Creation of Consolidated': 'Creación de Consolidados',
    'Payment Creation': 'Creación de Pagos',
    'Quote Creation': 'Creación de Cotización',
    'Invoice Creation': 'Creación de Facturas',
    'Client Creation': 'Creación de Clientes',
    'Tracking Link': 'Enlace de Tracking',
    'Pickup Creation': 'Creación de Pickups',
    'Mobile App Configuration': 'Configuracion de App Mobile',
    'Creation of Delivery Lists': 'Creación de Listas de Entregas',
    'Creation of AWB': 'Creación de AWB',
    'System Users': 'Usuarios Sistema',
    'PoBox Users': 'Usuarios Casillero',
    'Creation of PoBox': 'Creación de Casilleros',
    'Viewing in PoBox': 'Visualización en Casilleros',
    'Guide Settings': 'Configuración de Guías',
    'Master Guide': 'Guía Master',
    'Master Guide Label': 'Etiqueta para Guía Master',
    'Tariff Item': 'Partida Arancelaria',
    'Exchange Rate': 'Tasa de Cambio',
    'Show payment COD': 'Mostrar pago COD',
    'Assign user to the Guide': 'Asignar usuario a la Guía',
    'Show Commission': 'Mostrar Comisión',
    'Allow creating status when finished':
        'Permitir crear status cuando este finalizada',
    'Request Package Type': 'Pedir Tipo de Paquete',
    'Request Tracking': 'Pedir Tracking',
    'Mandatory package tracking': 'Tracking del paquete obligatorio',
    'Mandatory package value': 'Valor del paquete obligatorio',
    'Content Label': 'Etiqueta para Contenido',
    'Select client to invoice': 'Seleccionar cliente a facturar',
    'Bill to': 'Facturar a',
    'Mandatory Agency': 'Agencia Obligatoria',
    'Mandatory Agent': 'Agente Obligatorio',
    'Auxiliary Date': 'Fecha Auxiliar',
    'Auxiliary Date Label': 'Etiqueta de Fecha Auxiliar',
    'Dangerous content option': 'Opción de contenido peligroso',
    'Show transferable option': 'Mostrar opción transferible',
    'Marked as transferable': 'Marcada como transferible',
    'Updatable in consolidated form and/or with invoice':
        'Actualizable en consolidado y/o con factura',
    'Auxiliary Text Field': 'Campo de Texto Auxiliar',
    'Auxiliary Label': 'Etiqueta Auxiliar',
    'Label Date Auxiliary 2': 'Etiqueta Fecha Auxiliar 2',
    'Auxiliary Date 2 Mandatory': 'Fecha Auxiliar 2 Obligatoria',
    'Initial Payment': 'Pago Inicial',
    'Initial Payment Label': 'Etiqueta Pago Inicial',
    'Numeric field that is subtracted from the total':
        'Campo numérico que se resta del total',
    'Label for numeric field that is subtracted from the total':
        'Etiqueta para campo numérico que se resta del total',
    'Assign the most recent part status to the Guide':
        'Asignar el estado de pieza más reciente a la Guía',
    'Calculate distance with google': 'Calcular distancia con google',
    'Avoid Highways': 'Evitar Autopistas',
    'Avoid Tolls': 'Evitar Peajes',
    Additional: 'Adicional',
    finishAllPackages:
        'Al finalizar, todos los paquetes extraídos y no extraídos heredarán el estado finalizado en la guía.',
    'Chargeable volume': 'Volumen cargable',
    'Loadable Volume Value': 'Valor de Volumen cargable',
    'Just basic data': 'Solo datos básicos',
    'Bill on creation': 'Facturar al crear',
    'Default Services': 'Servicios Predeterminados',
    'Agency for delivery notes': 'Agencia para notas de entrega',
    'Copy of creation emails': 'Copia de emails de creación',
    'Copy of Email to': 'Copia de Email a',
    'Quick Warehouse Options': 'Opciones de Warehouse Rápido',
    'Agent at Rapid Warehouse': 'Agente en Warehouse Rápido',
    'Description in Quick Warehouse': 'Descripción en Warehouse Rápido',
    'Clear Agency Warehouse Fast': 'Limpiar Agencia Warehouse Rápido',
    'Quick Warehouse with enter control':
        'Warehouse Rápido con control de enter',
    'Need Sender Required in false': 'Necesita Remitente Obligatorio en falso',
    'Days to send': 'Días para enviar',
    Repacking: 'Reempaques',
    Searches: 'Búsquedas',
    Document_Description:
        'Gestionar, buscar, etiquetas, acciones masivas y reportes',
    Searches_Description:
        'Encuentra rápidamente elementos por criterios de búsqueda.',
    Transporters: 'Transportistas',
    'Include items without recipient': 'Incluir artículos sin destinataria',
    'Required City': 'Ciudad requerida',
    'Sender and Recipient can be the same':
        'El remitente y el destinatario pueden ser el mismo',
    'Update even if you have items': 'Actualizar incluso si tienes artículos',
    'Generate Zip': 'Generar Zip',
    'Auxiliar Label Date': 'Fecha de etiqueta auxiliar',
    'City Label': 'Etiqueta de ciudad',
    'Mandatory Auxiliar Date': 'Fecha auxiliar obligatoria',
    'Auxiliar Label': 'Etiqueta auxiliar',
    'Required Auxiliar 2': 'Auxiliar 2 requerido',
    'Mandatory Auxiliar': 'Auxiliar obligatorio',
    'Auxiliar Label 2': 'Etiqueta auxiliar 2',
    'Document Label': 'Etiqueta del documento',
    'Mandatory Document': 'Documento obligatorio',
    'Audit Extra': 'Información adicional de auditoría',
    'Mandatory Audit Extra': 'Información adicional de auditoría obligatoria',
    'Audit Extra Label': 'Etiqueta de información adicional de auditoría',
    'Required Auxiliar': 'Auxiliar requerido',
    'Tax Label': 'Etiqueta de impuestos',
    'Show approximation options': 'Mostrar opciones de aproximación',
    'Auxiliary numeric number': 'Número numérico auxiliar',
    'Label for auxiliary numerical number':
        'Etiqueta para número numérico auxiliar',
    'Default value': 'Valor predeterminado',
    'Mandatory Currency': 'Moneda obligatoria',
    'Identity Document': 'Documento de identidad',
    Label: 'Etiqueta',
    'Tariff Group': 'Grupo tarifario',
    'Value Document ID': 'ID de documento de valor',
    Assistant: 'Asistente',
    'Assistant Label': 'Etiqueta del asistente',
    'Client Class': 'Clase de cliente',
    'Customer Type Label': 'Etiqueta de tipo de cliente',
    'Mandatory Customer Type': 'Tipo de cliente obligatorio',
    'Customer Type Options': 'Opciones de tipo de cliente',
    'Assistant Date': 'Fecha del asistente',
    'Automatically assign the corresponding agent in logistics operations':
        'Asignar automáticamente el agente correspondiente en las operaciones logísticas',
    'Assistant Date Label': 'Etiqueta de fecha del asistente',
    'Assistant Date Mandatory': 'Fecha del asistente obligatoria',
    'Location Mandatory': 'Ubicación obligatoria',
    'Mobile Mandatory': 'Móvil obligatorio',
    'Document ID Mandatory': 'ID de documento obligatorio',
    'Non-repeated Email': 'Correo electrónico no repetido',
    'Assistant Date 1': 'Fecha del asistente 1',
    'Assistant Label 1': 'Etiqueta del asistente 1',
    'Mandatory Assistant 1': 'Asistente 1 obligatorio',
    'Assistant 2': 'Asistente 2',
    'Assistant Label 2': 'Etiqueta del asistente 2',
    'Mandatory Assistant 2': 'Asistente 2 obligatorio',
    'Non-repeated identity document': 'Documento de identidad no repetido',
    'Auto Required Pickup': 'Recogida automática requerida',
    'Show Sub Text': 'Mostrar texto secundario',
    'Public Search': 'Búsqueda pública',
    'Auxiliar Text 1': 'Texto auxiliar 1',
    'Auxiliar Text 2': 'Texto auxiliar 2',
    'Auxiliar Text 3': 'Texto auxiliar 3',
    'Auxiliar Text 4': 'Texto auxiliar 4',
    'Auxiliar Text 5': 'Texto auxiliar 5',
    'Required Expire Date': 'Fecha de expiración requerida',
    'Expire Date': 'Fecha de expiración',
    'Weight Unit': 'Unidad de peso',
    Accounting: 'Contabilidad',
    Dash: 'Panel',
    'Pack New': 'Nuevo paquete',
    'Pack New Fast': 'Paquete nuevo rápido',
    'Pack List': 'Lista de paquetes',
    'Pack Manage': 'Gestionar paquetes',
    'Pack New Prepack': 'Nuevo paquete preempaquetado',
    'Pack List Prepack': 'Lista de paquetes preempaquetados',
    'Pack Sys Receipt': 'Recepción de sistema de paquetes',
    'WH Rec New': 'Nuevo recibo de almacén',
    'WH Rec List': 'Lista de recibos de almacén',
    'WH Rec Manage': 'Gestionar recibos de almacén',
    'WH Rec In WR': 'Recibo de almacén en WR',
    'WH Rec Search': 'Buscar recibo de almacén',
    'WH Rec Sys Receipt': 'Recibo de sistema de almacén',
    'Guide New': 'Nueva guía',
    'Guide List': 'Lista de guías',
    'Guide Search': 'Buscar guía',
    'Guide for Pack': 'Guía para paquete',
    'Guide to Consol': 'Guía para consolidación',
    'Bag List': 'Lista de bolsas',
    'Bag New': 'Nueva bolsa',
    'Bag Receive': 'Recibir bolsa',
    'Bag to Consol': 'Bolsas para consolidación',
    'Load Unit New': 'Nueva unidad de carga',
    'Load Unit List': 'Lista de unidades de carga',
    'Consol New': 'Nueva consolidación',
    'Consol List': 'Lista de consolidaciones',
    'Consol Ship New': 'Nueva consolidación de envío',
    'Consol Ship List': 'Lista de consolidaciones de envío',
    Bills: 'Facturas',
    Graphs: 'Gráficos',
    Guides: 'Guías',
    'Track Packages': 'Rastrear Paquetes',
    'Repack Request': 'Solicitud de Reempaquetado',
    'Repack Tracking': 'Seguimiento de Reempaquetado',
    'Repack Packages': 'Reempacar Paquetes',
    'Repack Warehouse': 'Almacén de Reempaquetado',
    'Bill Warehouse': 'Factura de Almacén',
    'Bill Guides': 'Factura de Guías',
    'Pay Methods': 'Métodos de Pago',
    'Pay Notify': 'Notificación de Pago',
    'Pay Customer': 'Pagar al Cliente',
    'Pay Customer Unverified': 'Pagar Cliente No Verificado',
    Accounts: 'Cuentas',
    'Show PO Boxes': 'Mostrar Casilleros',
    'Show Data': 'Mostrar Datos',
    'Update Data': 'Actualizar Datos',
    'HTML Code': 'Código HTML',
    'HTML Head': 'Cabecera HTML',
    WAREHOUSE: 'ALMACEN',
    RECEPTION: 'RECEPCION',
    CONTROL: 'CONTROL',
    ANOTHER: 'OTRO',
    'Terms & Conditions': 'Términos',
    'Declared Value': 'Valor Declarado',
    None: 'Ninguno',
    'Pobox Address': 'Direcciónes del Casillero',
    'To send online purchases, commercial shipments, or packages: ':
        'Para enviar compras online, carga comercial o encomiendas: ',
    'To any of these addresses:': 'A cualquiera de estas direcciones:',
    'Select at least one item to send':
        'Seleccione por lo menos un item para enviar',
    required_field: 'El campo "{field}" es requerido para crear un paquete.',
    'You cannot repack a package that has already been processed':
        'No puedes reempacar un paquete que ya ha sido procesado',
    'Please add at least one package': 'Por favor, agrega al menos un paquete.',
    Tariffs: 'Tarifas',
    'Sea Ports': 'Puertos Marítimos',
    'Email setup': 'Correo',
    'Pack Types': 'Tipos de empaque',
    'Paid Types': 'Tipos de pago',
    'Shipment rate': 'Tarifa de Guía',
    'Warehouse rate': 'Tarifa de almacén',
    Carriers: 'Empresa de Transporte',
    Vehicles: 'Vehículos',
    Branches: 'Sucursales',
    PoBOX: 'Apartado Postal',
    'WareHouse Rate': 'Tarifa de Almacén',
    Flat: 'Fijo',
    Distance: 'Distancia',
    'Region Filter': 'Filtro de Región',
    'Calculation Method': 'Método de Cálculo',
    'Editable Price': 'Precio Editable',
    'Visible in the Quote': 'Visible en la Cotización',
    'Lower Limit': 'Límite Inferior',
    'Value to Pay': 'Valor a Pagar',
    'Additional Label': 'Etiqueta Adicional',
    'Warehouse Rate': 'Tarifa de Almacén',
    'Edit WareHouse Rate': 'Editar Tarifa de Almacén',
    'Create WareHouse Rate': 'Crear Tarifa de Almacén',
    'The first range must start at 0': 'El primer rango debe comenzar en 0',
    'The last range must have a maximum value greater than 0':
        'El último rango debe tener un valor máximo mayor que 0',
    'Range {index}: Minimum value must be less than maximum value':
        'Rango {index}: El valor mínimo debe ser menor que el valor máximo',
    'Range {index}: Price is required': 'Rango {index}: El precio es requerido',
    'Range {index}: Maximum value must equal the minimum value of the next range':
        'Rango {index}: El valor máximo debe ser igual al valor mínimo del siguiente rango',
    flat: 'Fijo',
    range: 'Rango',
    pieces: 'Piezas',
    volume: 'Volumen',
    weight: 'Peso',
    AllAgencies: 'Todas las agencias',
    'Rate type': 'Tipo Tarifa',
    'Shipment Rate': 'Tarifa Guia',
    'Upper Limit': 'Límite Superior',
    Profit: 'Ganancia',
    'Insurance Percentage': 'Porcentaje de Seguro',
    'Tax Percentage': 'Porcentaje de Impuesto',
    'Minimum Charge': 'Cargo Mínimo',
    'Minimun Limit': 'Límite Mínimo',
    Individual: 'Individual',
    'Minimum Price': 'Precio Mínimo',
    'Rate Ranges': 'Rangos de Tarifa',
    Minimum: 'Mínimo',
    Maximum: 'Máximo',
    'Minimum limit in units of measurement':
        'Límite mínimo en unidades de medida',
    Reopen: 'Abrir',
    'Send Notification': 'Enviar Notificación',
    Clear: 'Limpiar',
    'Accept and sign': 'Aceptar y firmar',
    Warehouse: 'Warehouse',
    Repack: 'Reempacar',
    'Receipt List': 'Lista Recibos',
    'Warehouse List': 'Lista Warehouse',
    'Repack in Warehouse': 'Reempacar en Warehouse',
    LoadUnits: 'Unidades de Carga',
    'Email Setup': 'Configuración de Correo',
    Service: 'Servicio',
    Item: 'Item',
    'Unit Measure': 'Unidad de Medida',
    'Unit Price': 'Precio Unit.',
    Discount: 'Descuento',
    'Shipment List': 'Lista de Guías',
    'LoadUnit List': 'Lista de Unidades de Carga',
    'Alternative name': 'Nombre Alternativo',
    'Volumetric Weight': 'Peso Volumétrico',
    'Add package': 'Agregar paquete',
    'Add Warehouse Receipt': 'Agregar Recibo de almacén',
    'Add Warehouse': 'Agregar Warehouse',
    'Add Shipment': 'Agregar Guía',
    'Add LoadUnit': 'Agregar Unidad de Carga',
    'Export to PDF': 'Exportar a PDF',
    'Export to Excel': 'Exportar a Excel',
    'Export to CSV': 'Exportar a CSV',
    'Save & Close': 'Guardar y cerrar',
    'Exit without saving': 'Salir sin guardar',
    'Are you sure you want to exit without saving?':
        '¿Estás seguro de que deseas salir sin guardar?',
    'Rate Price': 'Precio de tarifa',
    'Repacked Packages': 'Paquetes Reempaquetados',
    ACTIVO: 'ACTIVO',
    'Invalid email': 'Email inválido',
    'Press Enter or comma to add. Use Backspace to remove.':
        'Presiona Enter o coma para agregar. Usa Backspace para eliminar.',
    'Search by number (shipper, warehouse), email, name':
        'Buscar por número (remitente, almacén), correo, nombre',
    'The following items are already repacked: {numbers}':
        'Los siguientes artículos ya han sido reempaquetados: {numbers}',
    'Label configuration': 'Etiquetas',
    'Search by number (shipper, package, pobox), email, name':
        'Buscar por número (remitente, paquete, apartado postal), correo, nombre',
    'Search by number': 'Buscar por número',
    'Search by tracking': 'Buscar por seguimiento',
    'Search by number (shipper, pobox), email, name.':
        'Buscar por número (remitente, apartado postal), correo, nombre.',
    'Search by number, customer number, email, name':
        'Buscar por número, número de cliente, correo, nombre',
    'Search by number, customer number': 'Buscar por número, número de cliente',
    'Search by email, name': 'Buscar por correo, nombre',
    'Search by name': 'Buscar por nombre',
    Processing: 'Procesar',
    whrec: 'Warehouse',
    guide: 'Guía',
    receipt: 'Paquete',
    'Create Alert': 'Crear Alerta',
    'Processed by': 'Procesado por',

    'Label Package Configurations': 'Configuraciones de Etiqueta de Paquete',
    'Label Load Unit Configurations':
        'Configuraciones de Etiqueta de Unidad de Carga',
    'Label Pickups Configurations': 'Configuraciones de Etiqueta de Recogidas',
    'Label Shipment Configurations': 'Configuraciones de Etiqueta de Guía',
    'Label Alerts Configurations': 'Configuraciones de Etiqueta de Alertas',
    'Label Consolidated Configurations':
        'Configuraciones de Etiqueta de Consolidados',
    'Label Warehouse Configurations':
        'Configuraciones de Etiqueta de Warehouse',
    'Label AWB Configurations': 'Configuraciones de Etiqueta de AWB',
    'Label Management Configurations':
        'Configuraciones de Gestión de Etiquetas',
    'Label Package': 'Etiqueta de Paquete',
    'Label Shipment': 'Etiqueta de Guía',
    'Label Warehouse': 'Etiqueta de Warehouse',
    'Label Load Unit': 'Etiqueta de Unidad de Carga',
    'Label Alerts': 'Etiqueta de Alertas',
    'Label AWB': 'Etiqueta de AWB',
    'Label Pickups': 'Etiqueta de Recogidas',
    'Label Consolidated': 'Etiqueta de Consolidados',
    'Label Management': 'Gestión de Etiquetas',

    'Agency name': 'Nombre de la Agencia',
    'Agency Address': 'Dirección de la Agencia',
    'Agency City': 'Ciudad de la Agencia',
    'Agency Zip': 'Código Postal de la Agencia',
    'Agency Phone': 'Teléfono de la Agencia',
    'Agency Email': 'Correo de la Agencia',
    'Destination agency name': 'Nombre de la agencia de destino',
    'Destination agency address': 'Dirección de la agencia de destino',
    'Destination agency Zip': 'Código Postal de la agencia de destino',
    'Destination agency Phone': 'Teléfono de la agencia de destino',
    'Destination agency Email': 'Correo de la agencia de destino',

    'Consignee data': 'Destinatario',
    'Consignee name': 'Nombre Destinatario',
    'Consignee Address': 'Dirección Destinatario',
    'Consignee City': 'Ciudad Destinatario',
    'Consignee Zip': 'Código Postal del destinatario',
    'Consignee Phone': 'Teléfono Destinatario',
    'Consignee Mobile': 'Móvil Destinatario',
    'Consignee PoBOX': 'Casillero Destinatario',
    'Consignee Number': 'Número Destinatario',
    'Consignee Country': 'País Destinatario',
    'Consignee Full Address': 'Dirección Completa Destinatario',
    'COD Consignee City': 'Ciudad Destinatario COD',
    'Consignee DocID': 'DocID Destinatario',
    'Consignee CD State ZIP': 'Estado y Código Postal Destinatario',
    'Location for consignee': 'Ubicación para el destinatario',
    'Consignee Agency': 'Agencia del destinatario',
    'Packages warehouse consignee': 'Paquetes del almacén del destinatario',

    'Shipper data': 'Remitente',
    'Shipper name': 'Nombre del remitente',
    'Shipper Address': 'Dirección del remitente',
    'Shipper City': 'Ciudad del remitente',
    'Shipper Zip': 'Código Postal del remitente',
    'Shipper Phone': 'Teléfono del remitente',
    'Shipper Mobile': 'Móvil del remitente',
    'Shipper PoBOX': 'Casillero del remitente',
    'Shipper Number': 'Número del remitente',
    'Shipper Country': 'País del remitente',
    'Shipper Full Address': 'Dirección completa del remitente',
    'COD Shipper City': 'Ciudad del remitente COD',
    'Shipper DocID': 'Documento de Identidad del remitente',
    'Shipper CD State ZIP': 'Estado y Código Postal del remitente',
    'Location for shipper': 'Ubicación para el remitente',
    'Shipper Agency': 'Agencia del remitente',
    'Packages warehouse shipper': 'Paquetes del almacén del remitente',

    'Receipt Number': 'Número de Paquete',
    'Receipt Date': 'Fecha de Paquete',
    'Receipt Carrier': 'Transportista del Paquete',
    'Receipt Type': 'Tipo de Paquete',
    'Receipt ShippingType': 'Tipo de Envío del Paquete',
    'Receipt Description': 'Descripción del Paquete',
    'Receipt Tracking': 'Seguimiento del Paquete',
    'Receipt Value': 'Valor del Paquete',
    'Receipt Height': 'Altura del Paquete',
    'Receipt Width': 'Ancho del Paquete',
    'Receipt Volume': 'Volumen del Paquete',
    'Receipt Pieces': 'Piezas del Paquete',
    'Receipt Weight': 'Peso del Paquete',
    'Receipt Volume Weight': 'Peso Volumétrico del Paquete',
    'Receipt COD': 'COD del Paquete',
    'Receipt COD Tracking': 'Seguimiento COD del Paquete',
    'Receipt COD Unit': 'Unidad COD del Paquete',
    'Receipt Unit Volume': 'Volumen Unitario del Paquete',
    'Receipt Note': 'Nota del Paquete',
    'Receipt Agent': 'Agente del Paquete',
    'Receipt Location': 'Ubicación del Paquete',
    'QR Package with Unit': 'QR Paquete con Unidad',
    'QR Package Tracking': 'QR Tracking del Paquete',
    'QR Warehouse Receipt': 'QR Recibo de Almacén',
    'QR Guide': 'QR Guía',

    'Shipment Number': 'Número de Guía',
    'Shipment Date': 'Fecha de Guía',
    'Total shipment price': 'Precio total de la guía',
    'Shipment insured amount': 'Monto asegurado de la Guía',
    'Sending a Shipment': 'Enviando una Guía',
    'Declared shipment value': 'Valor declarado de la Guía',
    'Master shipment': 'Guía Maestra',
    'Tariff shipment heading': 'Partida arancelaria de la Guía',
    'Date and time of shipment': 'Fecha y hora de la Guía',
    'Pickup Guide Number': 'Número de Guía de Recogida',
    'Pickup Guide Route': 'Ruta de Guía de Recogida',
    'Shipment delivery route': 'Ruta de entrega de la Guía',
    'AWB Number': 'Número de AWB',
    'COD Payment': 'Pago COD',
    'Auxiliary Date 2': 'Fecha Auxiliar 2',
    'Dangerous Content': 'Contenido Peligroso',
    'Auxiliary Text': 'Texto Auxiliar',
    'Down payment': 'Pago Inicial',
    'Down payment 2': 'Pago Inicial 2',
    'Payment general tax': 'Impuesto general de pago',
    'Tariff tax': 'Impuesto arancelario',
    'Payment type': 'Tipo de Pago',
    'Freight tax': 'Impuesto de flete',

    'Warehouse Number': 'Número de Warehouse',
    'Warehouse Date': 'Fecha de Warehouse',
    'Warehouse note': 'Nota de Warehouse',
    'Warehouse INS': 'Seguro de Warehouse',
    'Pickup Warehouse Number': 'Número de Warehouse de Recogida',
    'Pickup Warehouse Route': 'Ruta de Warehouse de Recogida',
    'Warehouse delivery route': 'Ruta de entrega de Warehouse',
    'Warehouse Aux': 'Auxiliar de Warehouse',
    'Warehouse AWB number': 'Número de AWB de Warehouse',
    'Consolidated Number': 'Número de Consolidado',
    'Consolidated Alt. Name': 'Nombre Alt. Consolidado',
    'Load Unit Number': 'Número de Unidad de Carga',
    'Cod Auxiliary': 'Auxiliar de COD',
    'Invoice number': 'Número de factura',

    'LoadUnit Number': 'Número de Unidad de Carga',
    'LoadUnit Date': 'Fecha de Unidad de Carga',
    'LoadUnit note': 'Nota de Unidad de Carga',
    'LoadUnit Shipping': 'Envío de Unidad de Carga',
    'LoadUnit Origin Country': 'País de origen de Unidad de Carga',
    'LoadUnit Destination Country': 'País de destino de Unidad de Carga',
    'Total weight of LoadUnit': 'Peso total de Unidad de Carga',
    'Total volume of LoadUnit': 'Volumen total de Unidad de Carga',
    'Total volumetric weight': 'Peso volumétrico total',
    'Total pieces': 'Total de piezas',
    'Weight pieces': 'Peso de piezas',
    'Volume pieces': 'Volumen de piezas',
    'Unit pieces': 'Piezas unitarias',

    'Arrival Date': 'Fecha Llegada',
    'Auxiliary Field': 'Campo auxiliar',

    'Commodity Number': 'Número de mercancía',
    'Commodity measures': 'Medidas de mercancía',
    'Commodity pieces': 'Piezas de mercancía',
    'Commodity weight': 'Peso de mercancía',
    'AWB destination airport': 'Aeropuerto de destino de AWB',
    'AWB destination city': 'Ciudad de destino de AWB',
    'AWB destination country': 'País de destino de AWB',
    'Guide number house': 'Número de guía doméstica',
    'Pieces number house': 'Número de piezas domésticas',
    'Number of guides house': 'Número de guías domésticas',
    'Departure airport': 'Aeropuerto de salida',

    Collection: 'Recogida',
    'Collection Name': 'Nombre de la Recogida',
    'Collection Address': 'Dirección de la Recogida',
    'Collection Email': 'Correo de la Recogida',
    'Collection City': 'Ciudad de la Recogida',
    'Collection Zip': 'Código Postal de la Recogida',
    'Collection Phone': 'Teléfono de la Recogida',
    'Collection Mobile': 'Móvil de la Recogida',
    'Collection PoBox': 'Casillero de la Recogida',
    'Collection Number': 'Número de la Recogida',
    'Collection Country': 'País de la Recogida',
    'Collection State': 'Estado de la Recogida',
    'Collection full address': 'Dirección completa de la Recogida',
    'COD Collection city': 'Ciudad de la Recogida COD',
    'Collection docId': 'Documento de Identidad de la Recogida',
    'Collection location': 'Ubicación de la Recogida',
    'Collection agency': 'Agencia de la Recogida',

    'Delivery Name': 'Nombre de la Entrega',
    'Delivery Email': 'Correo de la Entrega',
    'Delivery City': 'Ciudad de la Entrega',
    'Delivery Zip': 'Código Postal de la Entrega',
    'Delivery Phone': 'Teléfono de la Entrega',
    'Delivery Mobile': 'Móvil de la Entrega',
    'Delivery PoBox': 'Casillero de la Entrega',
    'Delivery Number': 'Número de la Entrega',
    'Delivery Country': 'País de la Entrega',
    'Delivery State': 'Estado de la Entrega',
    'Delivery full address': 'Dirección completa de la Entrega',
    'COD Delivery city': 'Ciudad de la Entrega COD',
    'Delivery docId': 'Documento de Identidad de la Entrega',
    'Delivery location': 'Ubicación de la Entrega',
    'Delivery agency': 'Agencia de la Entrega',

    'Customer Email': 'Correo del Cliente',
    'Customer City': 'Ciudad del Cliente',
    'Customer Zip': 'Código Postal del Cliente',
    'Customer Phone': 'Teléfono del Cliente',
    'Customer Mobile': 'Móvil del Cliente',
    'Customer PoBox': 'Casillero del Cliente',
    'Customer Number': 'Número del Cliente',
    'Customer Country': 'País del Cliente',
    'Customer State': 'Estado del Cliente',
    'Customer full address': 'Dirección completa del Cliente',
    'COD Customer city': 'Ciudad del Cliente COD',
    'Customer docId': 'Documento de Identidad del Cliente',
    'Customer location': 'Ubicación del Cliente',
    'Customer agency': 'Agencia del Cliente',

    'Pickup Number': 'Número de Recogida',
    'Pickup hour range': 'Rango de horas de Recogida',
    'Pickup payment type': 'Tipo de pago de Recogida',
    'Pickup shipment type': 'Tipo de envío de Recogida',
    'Pickup note': 'Nota de Recogida',

    'Sending Office': 'Oficina de Envío',
    'Current agency': 'Agencia Actual',
    'Country of origin': 'País de origen',
    'Receiving office': 'Oficina de Recepción',
    'Country of destination': 'País de destino',
    'Auxiliary 1': 'Auxiliar 1',
    'Auxiliary 2': 'Auxiliar 2',
    'Total Pieces': 'Total de Piezas',
    'Total Packages': 'Total de Paquetes',
    'Total Shipments': 'Total de Guías',
    'Total Warehouse Receipts': 'Total de Warehouse',
    'Total Load Units': 'Total de Unidades de Carga',
    'Total weight': 'Peso total',
    'Total volume': 'Volumen total',
    'Total valor': 'Valor total',
    'Total guide weight': 'Total de guía peso',
    QR: 'QR',

    Elements: 'Elementos',
    Image: 'Imagen',
    Text: 'Texto',
    Line: 'Línea',
    LineV: 'Línea Vertical',
    Rectangle: 'Rectángulo',
    Barcode: 'Código de Barras',
    'Invoice cancelled.': 'Factura cancelada.',

    // Reports
    'reports.error.generate': 'Error al generar el reporte',
    'Print.label': 'Etiqueta',
    'Print.delivery.note': 'Nota de Entrega',
    'Print.shippers.declaration': 'Declaración de Remitente',

    'Confirm clear format': '¿Desea limpiar el formato?',
    'Cannot save a label without elements.':
        'No se puede guardar una etiqueta sin elementos.',
    lineh: 'Línea Horizontal',
    linev: 'Línea Vertical',
    Position: 'Posición',
    Size: 'Tamaño',
    Margins: 'Márgenes',
    Canvas: 'Lienzo',
    Styles: 'Estilos',
    Logo: 'Logo',
    Verified: 'Verificado',
    Verify: 'Verificar',
    'Verify Payment': 'Verificar Pago',
    'Not Verified': 'No Verificado',
    'Invoice Number': 'Número de Factura',

    // Error handling translations
    'saving invoice': 'guardando factura',
    'removing item': 'eliminando item',
    'deleting payment': 'eliminando pago',
    'An error occurred while {operation}':
        'Ocurrió un error mientras {operation}',
    'Error {operation}: {errorMsg}': 'Error {operation}: {errorMsg}',

    shipper_name: 'Nombre remitente',
    receiver_name: 'Nombre destinatario',
    description: 'Detalles',
    instruction: 'Tipo de envío',

    agency_name: 'Nombre de la agencia',
    agency_address: 'Dirección de la agencia',
    agency_email: 'Email de la agencia',
    agency_phone: 'Teléfono de la agencia',

    link_pobox: 'Link Casillero',
    link_tracking: 'Link Tracking',
    link_company: 'Link Empresa',
    change_instruction_link: 'Cambio Tipo de Envío',
    link_signature: 'Enlace Firma',
    link_locker: 'Enlace Casillero',

    receiver_fullname: 'Nombre completo destinatario',
    receiver_address: 'Dirección destinatario',
    receiver_pobox: 'Casillero destinatario',
    receiver_mobile: 'Móvil destinatario',
    receiver_country: 'País destinatario',
    receiver_state: 'Estado destinatario',
    receiver_docid: 'Documento destinatario',

    shipper_fullname: 'Nombre completo remitente',
    shipper_address: 'Dirección remitente',
    shipper_pobox: 'Casillero remitente',
    shipper_mobile: 'Móvil remitente',
    shipper_country: 'País remitente',
    shipper_state: 'Estado remitente',
    shipper_docid: 'Documento remitente',

    note: 'Nota',
    aux: 'Referencia',

    customer_name: 'Nombre cliente',
    customer_lastname: 'Apellido cliente',
    customer_address: 'Dirección cliente',
    customer_city: 'Ciudad cliente',
    customer_state: 'Estado cliente',
    customer_country: 'País cliente',
    customer_email: 'Email cliente',
    customer_mobile: 'Móvil cliente',
    customer_phone: 'Teléfono cliente',
    customer_pobox: 'Casillero cliente',
    customer_number: 'Número cliente',

    element_type: 'Tipo de elemento',
    location_code: 'Código de ubicación',
    agent_fullname: 'Nombre del agente',

    total_pieces: 'Total piezas',
    total_weight: 'Total peso',
    total_volume: 'Total volumen',

    sender_name: 'Nombre remitente',
    addressee_name: 'Nombre destinatario',
    contain: 'Contenido',
    shipping_type: 'Tipo de envío',

    agent_name: 'Nombre agente',

    master_guide: 'Guía maestra',
    details: 'Detalles',

    sender: 'Remitente',
    receiver: 'Destinatario',

    guide_number: 'Número guía',
    status_date: 'Fecha status',
    status_comment: 'Comentario estado',
    request_date: 'Fecha de solicitud',
    destination_city: 'Ciudad destino',
    package_details: 'Detalles del paquete',

    warehouse_number: 'Número almacén',
    status_city: 'Ciudad estado',
    status_type: 'Tipo de estado',

    pobox_username: 'Usuario casillero',

    paid_amount: 'Monto pagado',
    unpaid_amount: 'Monto no pagado',
    stripe_payment_link: 'Enlace de pago de Stripe',
    invoice_total: 'Total factura',
    invoice_number: 'Número factura',

    pickup_number: 'Número Pickup',
    pickup_date: 'Fecha Pickup',
    pickup_hours: 'Horas Pickup',
    pickup_payment_type: 'Tipo de Pago Pickup',
    pickup_shipping_type: 'Tipo de Envío Pickup',
    pickup_note: 'Nota Pickup',
    operation_type: 'Tipo de Operación',

    pickup_name: 'Nombre Pickup',
    pickup_address: 'Dirección Pickup',
    pickup_phone: 'Teléfono Pickup',
    pickup_mobile: 'Móvil Pickup',
    pickup_email: 'Email Pickup',

    delivery_name: 'Nombre Entrega',
    delivery_address: 'Dirección Entrega',
    delivery_phone: 'Teléfono Entrega',
    delivery_mobile: 'Móvil Entrega',
    delivery_email: 'Email Entrega',

    'You have unsaved changes. Do you want to exit anyway?':
        'Tienes cambios sin guardar. ¿Deseas salir de todas formas?',
    Spanish: 'Español',
    English: 'Inglés',
    Language: 'Idioma',
    Action: 'Acción',
    'New Invoice': 'Nueva Factura',
    'New Customer': 'Nuevo Cliente',
    'New Warehouse': 'Nuevo Almacén',
    'New Shipment': 'Nueva Guía',
    'New Package': 'Nuevo Paquete',
    'New Pickup': 'Nuevo Pickup',
    'Status Change': 'Cambio de Estado',
    Completation: 'Finalización',
    'New QInvoice': 'Nueva Factura Q',

    // Customer translations
    'Create Customer': 'Crear Cliente',
    'Edit Customer': 'Editar Cliente',
    'Customer Addresses': 'Direcciones del Cliente',
    'Error loading addresses': 'Error cargando direcciones',
    'Error saving customer': 'Error guardando cliente',
    'Error loading address': 'Error cargando dirección',
    'Error creating address': 'Error creando dirección',
    'Error updating address': 'Error actualizando dirección',
    'Edit Address': 'Editar Dirección',
    'Create Address': 'Crear Dirección',
    'New Address': 'Nueva Dirección',

    // Form section titles
    Emails: 'Correos',

    // AddressTable translations
    Default: 'Predeterminado',
    Delete: 'Eliminar',

    // Buttons
    Update: 'Actualizar',

    address: {
        delete: {
            title: 'Eliminar Dirección',
            message: '¿Está seguro de que desea eliminar esta dirección?',
            success: 'Dirección eliminada exitosamente'
        },
        save: {
            success: 'Dirección guardada exitosamente'
        },
        validation: {
            customerRequired: 'Debe guardar el cliente primero'
        }
    },

    // Print label error messages
    'Unsupported entity type for label printing':
        'Tipo de entidad no soportado para impresión de etiqueta',
    'Invalid entity ID for label printing':
        'ID de entidad no válido para impresión de etiqueta',
    'Error generating label': 'Error al generar la etiqueta',
    'No Category': 'Sin Categoría',

    // Configuración de despliegue
    AWB: 'AWB',
    OPENED: 'ABIERTO',
    CLOSED: 'CERRADO',
    POBOX: 'PO Box',
    'Pobox Dash': 'Panel de PO Box',
    Payment: 'Pago',
    Paquetes: 'Paquetes',
    Reempaques: 'Reempaques',
    Facturación: 'Facturación',
    Pagos: 'Pagos',
    Alertas: 'Alertas',
    Información: 'Información',
    'Sección principal de la visualización de Casillero':
        'Sección principal de la visualización de Casillero',
    'HTML Mobile': 'HTML Móvil',

    Quotes: 'Cotizaciones',
    'List Quotes': 'Lista de Cotizaciones',
    Information: 'Información',
    'Welcome Dashboard': 'Dashboard de bienvenida',

    // Registro
    'Create your locker': 'Crea tu casillero',
    'Registering a locker is fast and free - without commitments or contracts.':
        'Registrar un casillero es rápido y gratuito - sin compromisos ni contratos.',
    'Account type': 'Tipo de cuenta',
    Person: 'Persona',
    'Personal information': 'Información personal',
    'Last name': 'Apellido',
    'Identity document': 'Documento de Identidad',
    'Search City': 'Buscar Ciudad',
    'Account credentials': 'Credenciales de cuenta',
    'Repeat Email': 'Repita Email',
    'Repeat Password': 'Repita Password',
    'Create Locker': 'Crear Casillero',
    'Already have an account?': '¿Ya tienes cuenta?',
    'Sign in here': 'Inicia sesión aquí',
    "Don't have an account?": '¿No tienes cuenta?',
    'Create your locker here': 'Crea tu casillero aquí',
    'Name is required': 'El nombre es requerido',
    'Name must be at least 2 characters':
        'El nombre debe tener al menos 2 caracteres',
    'Mobile is required': 'El móvil es requerido',
    'Invalid phone format': 'Formato de teléfono inválido',
    'Address is required': 'La dirección es requerida',
    'Address must be at least 10 characters':
        'La dirección debe tener al menos 10 caracteres',
    'City is required': 'La ciudad es requerida',
    'Email is required': 'El email es requerido',
    'Invalid email format': 'Formato de email inválido',
    'Repeat email is required': 'Repetir email es requerido',
    'Emails do not match': 'Los emails no coinciden',
    'Password must be at least 6 characters':
        'La contraseña debe tener al menos 6 caracteres',
    'Repeat password is required': 'Repetir contraseña es requerido',
    'Passwords do not match': 'Las contraseñas no coinciden',
    'I agree to the terms and conditions': 'Acepto los términos y condiciones',
    'I agree to the': 'Acepto los',
    'Terms and conditions': 'Términos y condiciones',
    'reCAPTCHA verification failed': 'Verificación reCAPTCHA falló',
    'Please complete the reCAPTCHA verification':
        'Por favor completa la verificación reCAPTCHA',
    'You must accept the terms and conditions':
        'Debes aceptar los términos y condiciones',
    'Enter phone number': 'Ingresa número de teléfono',
    POBox: 'Casillero',
    'Pack/WR': 'Paquete/Recibo',
    'Processed Date': 'Fecha de Procesamiento',
    'Repack In Warehouse': 'Reempacar en Almacén',
    'Create Invoice': 'Crear Factura',
    'Show Invoice': 'Mostrar Factura',
    'Send to QuickBooks': 'Enviar a QuickBooks',
    'Service List': 'Lista de Servicios',
    'Send Email': 'Enviar Email',
    'You do not have permission to view': 'No tienes permisos para ver',
    'Search by number (shipper, pobox), email, name':
        'Buscar por número (remitente, casillero), email, nombre',
    Receipt: 'Paquete',
    'Repacking type': 'Tipo de Solicitud',
    '0.5 superior': '0.5 superior',
    'Entero superior': 'Entero superior',
    'Entero mas cercano': 'Entero más cercano',
    'Redondeo condicional >=0.5 al entero superior':
        'Redondeo condicional >=0.5 al entero superior',
    twilio_actions: {
        new_invoice: 'Nueva Factura',
        new_customer: 'Nuevo Cliente',
        new_warehouse: 'Nuevo Recibo de Almacén',
        new_guide: 'Nueva Guía',
        new_package: 'Nuevo Paquete',
        new_pickup: 'Nuevo Pickup',
        status_change: 'Cambio de Estado',
        completation: 'Finalización',
        new_qinvoice: 'Nueva Factura Q'
    },

    'Generated by': 'Generado por',
    'Info Auxiliary': 'Información Auxiliar',
    no_entities_to_repack:
        'No hay paquetes o recibos de almacén disponibles para procesar esta solicitud de re-empaque.',
    COBRADA: 'COBRADA',
    'Search By Tracking': 'Buscar por tracking',
    'Search By Number': 'Buscar por número',
    'Search By Description': 'Buscar por descripción',
    'Search By Email': 'Buscar por correo',
    'Search By Name': 'Buscar por nombre',
    'Search By POBox': 'Buscar por casillero',
    'Pickup Information': 'Información de Recogida',
    'Delivery Information': 'Información de Entrega',
    'Address Line 2': 'Dirección Línea 2',
    'Save Line': 'Guardar Línea',
    'Delete Line': 'Eliminar Línea',
    'Barcode Scanner': 'Escáner de Código de Barras',
    'Print Label': 'Imprimir Etiqueta',
    'Deliver to agency': 'Entregar a Agencia',
    globalSearch: {
        byPackageTracking: 'Tracking Paquete',
        byPackageDescription: 'Descripción Paquete',
        byPackageNumber: 'Número  Paquete',
        byWarehouseReceiptNumber: 'Número Warehouse',
        byShipmentNumber: 'Número Guía',
        byInvoiceNumber: 'Número Factura',
        byCustomerInfo: 'Cliente'
    },
    'Shipping Requests': 'Solicitudes de envío',
    'Are you sure you want to verify this payment?':
        '¿Está seguro de que desea verificar este pago?',
    'Add Services': 'Añadir Servicios',
    'Tax Amount': 'Cantidad de Impuesto',
    'Item Type': 'Tipo',
    'Item Number': 'Número',
    'My Info': 'Mi información',
    'Scheduled for': 'Programado para',
    Opened: 'Abierto',
    Closed: 'Cerrado',
    'Pickups Routes': 'Rutas de Pickups',
    'Pickups List': 'Lista de Pickups',
    'Add pickups from any agency': ' Agregar pickups de cualquier agencia',
    Abierta: 'Abierta',
    Cerrada: 'Cerrada',
    'Actualizar Paquetes': 'Actualizar Paquetes',
    'Consolidar en Guía': 'Consolidar en Guía',
    'Consolidar en Whrec': 'Consolidar en Whrec',
    'Procesado en': 'Procesado en',
    Correlative: 'Correlativo',
    'Correlative Numbers': 'Números Correlativos',
    'Correlative Type': 'Tipos Correlativos',
    'Document Type': 'Tipos de Documento',
    'Last Number': 'Último número',
    'Last Update': 'Última Actualización',
    'No more items': 'No hay más registros',
    Routes: 'Rutas',
    timeRange: 'La hora "Hasta" debe ser mayor que la hora "Desde"',
    'Invalid session. Please complete your payment first.':
        'Sesión inválida. Por favor complete su pago primero.',
    'The session is not correct.': 'La sesión no está correcta.',
    'Error verifying session. Please try again.':
        'Error al verificar la sesión. Por favor, intente nuevamente.',
    'Public Links': 'Enlaces Públicos',
    'Cargo Verification': 'Verificación de Carga',
    'List consolchecks': 'Listar verificación de carga',
    'Create consolcheck': 'Crear Verificación de carga',
    Numbering: 'Numeración'
};
